// The client is the auction owner; it subscribes to the client-namespaced bidding channel.
// (The establishment panel uses the Establishment:: channel; the admin panel the Admin:: one.)
export const AUCTION_BIDDING_CHANNEL = 'Client::Maintenance::EstablishmentChoice::AuctionEntries::BiddingChannel';
